import React from "react";
import { useNavigate } from "react-router-dom";
import InfoBox from "common-ui-components/components/info-box/InfoBox";
import { navigateToManualDeployment } from "../../../view/Vulnerabilities/utils/vulnerabilityUtils";
import styles from "./ThreatsDashboardPanels.module.css";

const asNumber = (value) => Number(value) || 0;

const RecommendationsPanel = ({ data }) => {
  const navigate = useNavigate();
  const recommendations = [];
  const vulnerability = data?.vulnerabilityDTO;
  const endOfLife = data?.endOfLifeData;
  const localPorts = data?.localPorts || [];

  if (vulnerability) {
    const detailsUrl = `/app/secure/threats/vulnerabilities/cve-details?cveId=${encodeURIComponent(vulnerability.cveId || "")}`;
    const openDetails = () =>
      navigate(detailsUrl, {
        state: { orgVulnerabilityId: vulnerability.orgVulnerabilityId },
      });
    recommendations.push({
      title: `Patch ${vulnerability.severity || "priority"} ${vulnerability.cveId || "vulnerability"}`,
      detail: `${vulnerability.vulnerableSoftware || "Affected software"} has a ${vulnerability.severity || "high-priority"} vulnerability${vulnerability.cvssScore != null ? ` (CVSS ${vulnerability.cvssScore})` : ""}.`,
      count:
        vulnerability.count == null
          ? "Endpoints unavailable"
          : `${asNumber(vulnerability.count)} endpoints`,
      action: "Patch",
      onClick: openDetails,
      onAction: () =>
        vulnerability.orgPatchId
          ? navigateToManualDeployment(navigate, [vulnerability])
          : openDetails(),
    });
  }

  if (asNumber(data?.overDues) > 0) {
    recommendations.push({
      title: "Clear past-due vulnerabilities",
      detail: `${asNumber(data.overDues).toLocaleString()} vulnerabilities have passed their remediation due date.`,
      count: `${asNumber(data.overDues).toLocaleString()} overdue`,
      action: "Remediate",
      onClick: () => navigate("/app/secure/threats/vulnerabilities"),
    });
  }

  if (endOfLife) {
    recommendations.push({
      title: `Replace end-of-life ${endOfLife.softwareName || "software"}`,
      detail: `${endOfLife.vendorName || "Software"}${endOfLife.versionName ? ` ${endOfLife.versionName}` : ""} reached end of life${endOfLife.endOfLifeDate ? ` on ${endOfLife.endOfLifeDate}` : ""}.`,
      count: `${asNumber(endOfLife.deviceCount)} systems`,
      action: "Review",
      onClick: () => navigate("/app/secure/threats/high-risk-software"),
    });
  }

  if (localPorts.length > 0) {
    recommendations.push({
      title: "Review exposed local ports",
      detail: `${data.deviceName || "A device"} has local ports ${localPorts.join(", ")} open.`,
      count: `${localPorts.length} ports`,
      action: "Review",
      onClick: () => navigate("/app/secure/threats/port-audit/summary"),
    });
  }

  // TODO: Restore the recommendations subheading when its guidance copy is ready.
  return (
    <InfoBox
      header="Recommendations"
      className={styles.panel}
      childrenProps={{ className: styles.recommendationContent }}
    >
      {recommendations.length ? (
        recommendations.map((item) => (
          <div className={styles.recommendation} key={item.title}>
            <div className={styles.recommendationText}>
              <strong>{item.title}</strong>
              <span title={item.detail}>{item.detail}</span>
            </div>
            <span className={styles.countBadge} title={item.count}>{item.count}</span>
            <button
              type="button"
              className={styles.secondaryButton}
              onClick={item.onClick}
            >
              View data
            </button>
            <button
              type="button"
              className={styles.primaryButton}
              onClick={item.onAction || item.onClick}
            >
              {item.action}
            </button>
          </div>
        ))
      ) : (
        <div className={styles.emptyState}>
          No recommendation details are available yet.
        </div>
      )}
    </InfoBox>
  );
};

export default RecommendationsPanel;
